    <nav>
      <ul class="pagination pagination-circle pg justify-content-center">
        <li class="page-item" [ngClass]="pageNumber === 1 ? 'page-item disabled' : 'page-item'">
          <a class="page-link"  (click)="firstPage()">First</a>
        </li>
        <li  class="page-item" [ngClass]="pageNumber === 1 ? 'page-item disabled' : 'page-item'">
          <a class="page-link" (click)="previousPage()" title="Previous">
            <span aria-hidden="true">&laquo;</span>
            <span class="sr-only">Previous</span>
          </a>
        </li>
        <li class="page-item active">
          <a class="page-link">{{pageNumber}}</a>
        </li>
        <li class="page-item" [ngClass]="pageNumber === totalPages ? 'page-item disabled' : 'page-item'">
          <a class="page-link" (click)="nextPage()" title="Next">
            <span aria-hidden="true">&raquo;</span>
            <span class="sr-only">Next</span>
          </a>
        </li>
        <li class="page-item" [ngClass]="pageNumber === totalPages ? 'page-item disabled' : 'page-item'">
          <a class="page-link" (click)="lastPage()">Last</a>
        </li>
      </ul>
    </nav>
